import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 0S ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 1min ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 5min ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 10min ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-question" }, null, -1)
const _hoisted_7 = { class: "transfer-header" }
const _hoisted_8 = { class: "transfer-header-item" }
const _hoisted_9 = { class: "transfer-header-item" }
const _hoisted_10 = { class: "transfer-header" }
const _hoisted_11 = { class: "transfer-header-item" }
const _hoisted_12 = { class: "transfer-header-item" }
const _hoisted_13 = { style: {"padding":"8px","background":"#fff"} }
const _hoisted_14 = {
  style: {"width":"115px"},
  class: "zhpy"
}
const _hoisted_15 = { style: {"text-align":"left"} }
const _hoisted_16 = { class: "transfer-search" }
const _hoisted_17 = { style: {"padding":"8px","background":"#fff"} }
const _hoisted_18 = {
  style: {"width":"115px"},
  class: "zhpy"
}
const _hoisted_19 = { style: {"text-align":"left"} }
const _hoisted_20 = { class: "transfer-search" }
const _hoisted_21 = { class: "transfer-option-key" }
const _hoisted_22 = { class: "transfer-option-name" }

import { defineComponent, reactive, toRefs, ref, onMounted } from 'vue'
import type { VNode, VNodeProps } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { api } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { getLoginName, getLoginId } from '@/utils/cookies'
import { trigger } from '@vue/reactivity'
import { useI18n } from "vue-i18n";
interface Option {
  key: number
  label: string
  disabled: boolean
}
interface stateTypes {
  data: { key: String, label: String, name: String }[]
  gids: { key: String, label: String }[]
}
interface funclistTypes {
  funcList: { id: number, name: String }[]
}
interface Virtua {
  adminVirtua: any
  adminVirtuaOne: any
  adminVirtuaThree:any
  adminPermanent: any
}

export default _defineComponent({
  expose: [],
  setup(__props) {

const { t } = useI18n();
const route = useRoute()
const routerList = useRouter()
const getloginName = getLoginName()
const getloginId = getLoginId()
const userForm = ref()
const Virtua = reactive<Virtua>({
  adminVirtua: 0,
  adminVirtuaOne: 0,
  adminVirtuaThree:0,
  adminPermanent:0
})
const permessionList: any = ref([]);
const permessionListInit = JSON.parse(
  localStorage.getItem("perrsion") || ""
);
permessionListInit.map((item: any) => {
  permessionList.value.push(item.code);
});
// 表单校验
const rules = reactive({
  account: [
    { required: true, message: t('input.Please fill in the account number'), trigger: 'blur' },
    { min: 2, max: 16, message: t('input.The account length should be between 2 and 16 digits'), trigger: 'blur' },
    {
      validator: (rule: any, value: any, callback: any) => {
        const reg = /^[A-Za-z0-9_]+$/
        if (!reg.test(value)) {
          callback(new Error(t('input.Please enter letters or numbers or combinations')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],

  password: [
    { required: true, message: t('input.Please input password'), trigger: 'blur' },
    { min: 6, max: 12, message: t('input.Password length should be between 6 and 12 characters'), trigger: 'blur' },
    {
      validator: (rule: any, value: any, callback: any) => {
        const reg = /^[A-Za-z0-9_]+$/
        if (!reg.test(value)) {
          callback(new Error(t('input.Please enter letters or numbers or combinations')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  funcsList: [{ required: true, message: t('input.Please select function group'), trigger: 'change' }],
  funcValueList: [
    {
      required: true,
      message: t('input.Please select the corresponding permissions'),
      trigger: 'change'
    }
  ],
  joinGids: [{ required: true, message: t('input.Please select the group'), trigger: 'change' }],
  defaultGid: [
    { required: true, message: t('input.Please select default group'), trigger: 'change' }
  ]
})
const uid = route.query.uid || ''
const isAccountReadonly = route.query.lockAccount === "1";
const checkDisabledType_func = ref(false) // false 为可编辑状态
const checkType_call = ref(true)
const dataList = reactive<stateTypes>({
  data: [],
  gids: []
})
const funcDataList = reactive<funclistTypes>({
  funcList: []
})
const rightSearchValue = ref('')
const leftSearchValue = ref('')
const formface = reactive({
  form: {
    type: ref(3), // 账号类型 0为三年期账号, 3为一年期账号
    uid: uid,
    joinGids: ref<any>([]),
    surlpusCount: 0,
    account: '',
    name: '',
    password: '',
    funcsList: ref<any>([]),
    validMonths: 0,
    funcValueList: ref<any>([]),
    imei: '',
    gpsInterval: ref(0),
    count: null,
    initNo: null,
    nameNo:null,
    leftValue: 1,
    defaultGid: '',
    remarks: ''
  }
})
// 穿梭框当前数据页
const dataPage = ref(1)
// 添加群组的穿梭框 左边的搜索事件
const filterMethod = (value: string) => {
  console.log('Left', value)
  getLeftData(value)

}
// 添加群组的穿梭框 右边的搜索事件
const filterMethodRight = (value: string) => {
  console.log('Reight! input')
}

const renderFunc = (
  h: (type: string, props: VNodeProps | null, children?: string) => VNode,
  option: Option
) => {
  return h('span', null, option.label)
}
const handleMoveToRight = (movedKeys: any) => {
  const movedItems = []
  for (const key of movedKeys) {
    // 从左侧数据中查找
    const item = dataList.data.find(item => item.key === key)
    if (item) {
      movedItems.push({
        key: item.key,
        name: item.name,
        label: item.label || item.name
      })
    }
  }
  // 添加到右侧（保留原有数据）
  dataList.gids = [...dataList.gids, ...movedItems]
  console.log('新增到右侧的数据:', movedItems)
}
const handleMoveToLeft = (movedKeys: any) => {
  // 从右侧数据中移除这些key对应的项
  dataList.gids = dataList.gids.filter(item => !movedKeys.includes(item.key))
  console.log('从右侧移除的数据keys:', movedKeys)
}
// 穿梭框触发的事件
const toggleChange = (value: any, direction: any, movedKeys: any) => {
  console.log('穿梭框触发?', value, direction, movedKeys)
  // dataList.gids = []
  // for (const i of value) {
  //   dataList.data.map((item) => {
  //     if (item.key === i) {
  //       dataList.gids.push({
  //         key: i,
  //         label: item.name
  //       })
  //     }
  //   })
  // }
  if (direction === 'right') {
    // 从左到右：添加数据到右侧
    handleMoveToRight(movedKeys)
  } else if (direction === 'left') {
    // 从右到左：从右侧移除数据
    handleMoveToLeft(movedKeys)
  }
}

const handelMoreGroup = async() => {
  console.log('查询更多群组~')
  let page = dataPage.value + 1
  dataPage.value = page
  const leftList: any = await api.list.userNoJoinGroupsList({
    uid: uid,
    pageNo: page || 1,
    pageSize: 500
  })
  const lList: any[] = dataList.data
  for (const i of leftList.data.data.resultList) {
    lList.push({
      key: i.gid,
      name: i.name,
      label: i.name
    })
  }
  dataList.data = lList
}

// 提交表单
const submit = () => {
  console.log('submit?')
  if (uid !== '') {
    userForm.value.validate(async(valid: any) => {
      if (valid) {
        console.log('提交?',formface )
        const status: any = await api.revise.userUpdate(formface.form)
        console.log(status, 'sub-edit-res?')
        if (status.data.status === 200) {
          userForm.value.resetFields()
          routerList.go(-1)
          ElMessage.success(t('table.modify success'))
        } else {
          ElMessage.warning(status.data.message)
        }
      } else {

      }
    })
  } else {
    userForm.value.validate(async(valid: any) => {
      console.log(formface)
      if (valid) {
        formface.form.funcsList = [formface.form.funcsList]
        const status: any = await api.revise.userAdd(formface.form)
        console.log(status, 'sub-add-res?')
        if (status.data.status === 200) {
          userForm.value.resetFields()
          routerList.push({ path: '/userlist' })
          ElMessage.success(t('table.success'))
        } else {
          ElMessage.warning(status.data.message)
        }
      } else {

      }
    })
  }
}

// 初始化
const getInfo = async(gname?: any) => {
  dataPage.value = 1
  if (uid !== '') {
    // 修改用户逻辑
    checkDisabledType_func.value = true

    const userInfo: any = await api.detail.userInfo({ uid: uid })
    const surlpusCount: any = await api.detail.adminVirtua({})
    const funcGroupData: any = await api.detail.groupFunList({
      pageNo: 1,
      pageSize: 1000
    })
    const userNoJoinGroupsList: any = await api.list.userNoJoinGroupsList({
      uid: uid,
      pageNo: 1,
      pageSize: 500,
      gname: gname
    })
    const userJoinGroupsList: any = await api.list.userJoinGroupsList({
      uid: uid,
      page: {
        pageNo: 1,
        pageSize: 5000
      },
      gname: gname
    })

    const { data } = userInfo.data
    const surlpus = surlpusCount.data.data
    const funcGroup = funcGroupData.data.data

    // 设置表单数据
    formface.form.account = data.account
    formface.form.name = data.name
    formface.form.password = data.password
    formface.form.imei = data.imei
    formface.form.defaultGid = data.defaultGid
    formface.form.gpsInterval = data.gpsInterval
    formface.form.remarks = data.remarks

    // 清空之前的选中数据
    formface.form.joinGids = []
    dataList.gids = []

    data.funcsList.map((i: any) => {
      formface.form.funcsList.push(parseInt(i))
    })

    formface.form.funcValueList = data.funcValueList
    funcDataList.funcList = funcGroup

    // 使用 Set 去重处理群组数据
    const lList: any = userNoJoinGroupsList.data.data.resultList || []
    const rList: any = userJoinGroupsList.data.data.resultList || []

    // 创建 Map 用于去重
    const groupMap = new Map()

    // 合并列表并去重
    const allGroups = [...lList, ...rList]
    allGroups.forEach(group => {
      if (group && group.gid && !groupMap.has(group.gid)) {
        groupMap.set(group.gid, group)
      }
    })

    // 转换为数组
    dataList.data = Array.from(groupMap.values()).map((group: any) => ({
      key: group.gid,
      name: group.name,
      label: group.name
    }))

    // 设置已选中的群组
    userJoinGroupsList.data.data.resultList.forEach((i: any) => {
      if (i && i.gid) {
        // 检查是否已存在
        const exists = formface.form.joinGids.includes(i.gid)
        if (!exists) {
          formface.form.joinGids.push(i.gid)
        }
        dataList.gids.push({
          key: i.gid,
          label: i.name
        })
      }
    })
  } else {
    // 新增用户逻辑 - 同样需要去重
    const AllVirtua: any = await api.detail.adminAllVirtua({})
    const funcGroupData: any = await api.detail.groupFunList({
      pageNo: 1,
      pageSize: 200,
      gname: gname
    })
    const userNoJoinGroupsList: any = await api.list.userNoJoinGroupsList({
      pageNo: 1,
      pageSize: 500,
      gname: gname
    })
    const validYears: any = await api.detail.validYears()

    Virtua.adminVirtua = AllVirtua.data.data[1]
    Virtua.adminVirtuaOne = AllVirtua.data.data[11]
    Virtua.adminVirtuaThree = AllVirtua.data.data[3]
    Virtua.adminPermanent = AllVirtua.data.data[4]

    const funcGroup = funcGroupData.data.data
    funcDataList.funcList = funcGroup

    const validMonth: any = validYears.data.data == 3 ? 36 : 12
    formface.form.validMonths = validMonth

    // 新增用户时也要去重
    const groups = userNoJoinGroupsList.data.data.resultList || []
    const groupMap = new Map()

    groups.forEach((group: any) => {
      if (group && group.gid && !groupMap.has(group.gid)) {
        groupMap.set(group.gid, group)
      }
    })

    dataList.data = Array.from(groupMap.values()).map((group: any) => ({
      key: group.gid,
      name: group.name,
      label: group.name
    }))
  }
}
// 穿梭款左侧后台查询
const getLeftData = async(gname?: any) => {
  const userNoJoinGroupsList: any = await api.list.userNoJoinGroupsList({
    uid: uid,
    pageNo: 1,
    pageSize: 500,
    gname: gname
  })
  const userJoinGroupsList: any = await api.list.userJoinGroupsList({
    uid: uid,
    page: {
      pageNo: 1,
      pageSize: 5000
    },
    gname: gname
  })
  // 当前查到的左侧列表数据
  const lList: any = userNoJoinGroupsList.data.data.resultList || []
  const rList: any = userJoinGroupsList.data.data.resultList || []
  console.log('搜索-左', lList)
  console.log('搜索-右', rList)
  const leftList = []
  const rightList = dataList.gids
  dataList.gids = []
  console.log('当前选中的-右', rightList)
  // 创建 Map 用于去重
  const groupMap = new Map()
  // 合并列表并去重
  lList.forEach(group => {
    if (group && group.gid && !groupMap.has(group.gid)) {
      groupMap.set(group.gid, group)
    }
  })
  rightList.forEach(item => {
    if (item && item.key && !groupMap.has(item.key)) {
      groupMap.set(item.key, item)
    }
  })
  // 转换为数组
  dataList.data = Array.from(groupMap.values()).map((group: any) => ({
    key: group.gid || group.key,
    name: group.name || group.label,
    label: group.name || group.label
  }))
  // 设置已选中的群组
  rightList.forEach((i: any) => {
    if (i && i.key) {
      // 检查是否已存在
      const exists = formface.form.joinGids.includes(i.key)
      if (!exists) {
        formface.form.joinGids.push(i.key)
      }
      dataList.gids.push({
        key: i.key,
        label: i.label
      })
    }
  })
  console.log('搜索完毕, 左侧数据:', dataList.data)
  console.log('右侧数据:', dataList.gids)
}
onMounted(() => {
  getInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: formface.form,
      "label-width": "120px",
      width: "200",
      rules: rules,
      ref: userForm
    }, {
      default: _withCtx(() => [
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(getloginName) + ':'
            }, {
              default: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t("statistics.Oneyearvirtualcurrency")) + ":" + _toDisplayString(Virtua.adminVirtuaOne) + "    ", 1),
                _createVNode("span", null, _toDisplayString(_ctx.$t("statistics.threeyearsvirtualcurrency")) + ":" + _toDisplayString(Virtua.adminVirtua) + "    ", 1),
                _createVNode("span", null, _toDisplayString(_ctx.$t("statistics.Industrycurrency")) + ":" + _toDisplayString(Virtua.adminVirtuaThree) + "    ", 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _ctx.$t('table.AccountType')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formface.form.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (formface.form.type = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: 3,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("form.OneYear")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 0,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("form.ThreeYears")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.Account'),
          prop: "account"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.account,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (formface.form.account = $event)),
              maxlength: "15",
              disabled: isAccountReadonly,
              placeholder: 
            _ctx.$t(
              'input.Please enter an account consisting of 2 to 15 digits or letters'
            )
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.name')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (formface.form.name = $event)),
              maxlength: "15",
              placeholder: 
            _ctx.$t(
              'input.The name consists of 15 digits or letters and underlined lines(Use * to indicate the position of the serial number)'
            )
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.password'),
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (formface.form.password = $event)),
              type: "password",
              maxlength: "12",
              disabled: !permessionList.value.includes(203) && _unref(uid) != '',
              placeholder: 
            _ctx.$t(
              'input.Please enter 6 to 12 characters to support letters and numbers'
            )
          
            }, null, 8, ["modelValue", "disabled", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: _ctx.$t('form.functiongroup'),
              prop: "funcsList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formface.form.funcsList,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (formface.form.funcsList = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(funcDataList.funcList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.Permission'),
          prop: "funcValueList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: formface.form.funcValueList,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (formface.form.funcValueList = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Group Call")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Switch Group")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 2 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Temp call")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 9 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("form.Across-groups temp call")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.IMEI')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.imei,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (formface.form.imei = $event)),
              maxlength: "16",
              placeholder: 
            _ctx.$t('input.Please enter the 12~16 digit IMEI number of the device')
          
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.GPS')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: formface.form.gpsInterval,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (formface.form.gpsInterval = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 0,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 60,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 300,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 600,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["label"]),
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: _ctx.$t('form.Quantity')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formface.form.count,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (formface.form.count = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: _ctx.$t('form.Initial Number')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formface.form.initNo,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (formface.form.initNo = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_unref(uid))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: _ctx.$t('form.name starting number')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formface.form.nameNo,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (formface.form.nameNo = $event)),
                  maxlength: "16",
                  placeholder: _ctx.$t('input.Please input Name Starting number')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('form.Join group'),
          prop: "joinGids"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_transfer, {
              modelValue: formface.form.joinGids,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (formface.form.joinGids = $event)),
              data: dataList.data,
              titles: [_ctx.$t('form.Group'), _ctx.$t('form.Selected')],
              onChange: toggleChange,
              class: "transfer-shell transfer-shell--user custom-transfer"
            }, {
              "left-header": _withCtx(() => [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("table.groupId")), 1),
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("table.designation")), 1)
                ])
              ]),
              "right-header": _withCtx(() => [
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("table.groupId")), 1),
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("table.designation")), 1)
                ])
              ]),
              "left-footer": _withCtx(() => [
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("table.groupId")), 1),
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("table.designation")), 1),
                  _createVNode("span", {
                    class: "text-span-more",
                    onClick: handelMoreGroup
                  }, _toDisplayString(_ctx.$t("table.more")), 1)
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_el_input, {
                    placeholder: _ctx.$t('input.Please enter a name to search'),
                    "prefix-icon": _ctx.Search,
                    onInput: filterMethod,
                    modelValue: leftSearchValue.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (leftSearchValue.value = $event)),
                    clearable: ""
                  }, null, 8, ["placeholder", "prefix-icon", "modelValue"])
                ])
              ]),
              "right-footer": _withCtx(() => [
                _createVNode("div", _hoisted_17, [
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("table.groupId")), 1),
                  _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("table.designation")), 1)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode(_component_el_input, {
                    placeholder: _ctx.$t('input.Please enter a name to search'),
                    "prefix-icon": _ctx.Search,
                    onInput: filterMethodRight,
                    modelValue: rightSearchValue.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (rightSearchValue.value = $event)),
                    clearable: ""
                  }, null, 8, ["placeholder", "prefix-icon", "modelValue"])
                ])
              ]),
              default: _withCtx(({ option }) => [
                _createVNode("span", _hoisted_21, _toDisplayString(option.key), 1),
                _createVNode("span", _hoisted_22, _toDisplayString(option.name), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "data", "titles"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.defaultgroup'),
          prop: "defaultGid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "m-2",
              placeholder: "Select",
              modelValue: formface.form.defaultGid,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (formface.form.defaultGid = $event))
            }, {
              default: _withCtx(() => [
                (dataList.gids.length !== 0)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(dataList.gids, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.key,
                        label: item.label,
                        value: item.key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('table.remarks')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formface.form.remarks,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (formface.form.remarks = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (submit())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("table.submit")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})